import React from 'react'
import {withToggles, withPopupToggles} from 'startlibs/lib/hocs'
import {Dialog, Button, Icon, ContextMenu, Li, ListItem} from 'startlibs/lib/components'
import {withForm, Form, AutoComplete, Field, Errors, SimpleCheckbox} from 'startlibs/lib/form'
import {ice} from 'icepath'
import styled, {css} from 'styled-components'
import {COUNTRIES_MAP} from '../../lib/CountriesCodes'
import './flags/flags.min.css'

const COUNTRIES = Object.entries(COUNTRIES_MAP)

const CountryFlag = styled.span `
  transform: scale(0.5) translateY(-50%);
  transform-origin: 0 0;
  position: absolute;
  left: 10px;
  top: 50%;
`

const CountrySelector = styled.span `
  cursor: pointer;
  margin-right: 2px;
  margin-left: -3px;
  color: rgba(0,0,0,0.4);
  position: relative;
  padding: 2px 4px 3px 28px;
  border-radius: 4px;
  :hover {
    background-color: rgba(0,0,0,0.05);
    color: rgba(0,0,0,0.5);
  }
  ${CountryFlag} {
    left: 4px;
  }
`

const CountrySelectorIcon = styled(Icon) `
  margin: 0 0.25rem;
  font-size: 12px;
`
const CountriesContextMenu = styled(ContextMenu) `
  max-height: 30rem;
  overflow: auto;
  margin-top: 2px;
  ${ListItem} {
    max-width: 220px;
    white-space: initial;
    a {
      padding-left: 3.5rem;
      padding-right: 1rem;
    }
  }
`

const AddedNumber = styled(AutoComplete.AddedBox)`
  padding-left: 3.25rem;
`

@withPopupToggles('contextMenu')
class PhoneInput extends React.Component {

  lastValue = ""

  onPaste = (ev) => {
    ev.preventDefault()
    const text = ev.clipboardData.getData('text')
    document.execCommand('insertText', false, this.props.format(text))
  }

  onInput = (e) => {
    const value = e.target.innerText
    const formatted = this.props.format(value.replace(/\D/g,'')).replace(/\D+$/,'')
    if (formatted === this.lastValue) {
      e.target.innerHTML = formatted
      let range = document.createRange()
      let sel = window.getSelection()
      const el = e.target.firstChild || e.target
      range.setStart(el, el.textContent.length)
      sel.removeAllRanges()
      sel.addRange(range)
    }
    this.props.onInput({target:{innerText:formatted}})
    this.lastValue = formatted;
  }

  render() {
    const {country, value, getCountryCallingCode, contextMenu, validator, onInput, format, popupTogglesId, ...rest} = this.props
    return <span>
      <CountrySelector onClick={contextMenu.open}>
        <CountryFlag className={"flag flag-"+(country.isOpen||"").toLowerCase()}/>
        <CountrySelectorIcon icon="arrow-down"/>
        +{getCountryCallingCode(country.isOpen)}
        {
          contextMenu.isOpen &&
          <CountriesContextMenu my="top left" at="bottom left" offset="-6 0">
            {COUNTRIES.map(([code, label]) => <Li.Simple selected={code===country.isOpen} label={<span><CountryFlag className={"flag flag-"+code.toLowerCase()}/>{label}</span>} key={code} onClick={() => country.open(code)}/>)}
          </CountriesContextMenu>
        }
      </CountrySelector>
      <AutoComplete.AutoCompleteTextboxDiv {...rest} onInput={this.onInput} onPaste={this.onPaste}/>
    </span>
  }
}

@withToggles('confirmFaxDialog', 'country')
@withForm()
export class SendFaxDialog extends React.PureComponent {

  state = {autoCompleteList: []}

  componentDidMount() {
    import('libphonenumber-js')
      .then(phoneValidator => this.setState({phoneValidator}))
    this.props.form.connector.setValue('faxes', [])
    this.props.country.open(this.props.fax.defaultCountry)
  }

  handleSubmit = () => {
    const faxes = this.getAllNumbers()
    return this.props.sendFaxFetcher({faxes}).catch((e) => {
      this.props.form.connector.setErrors({faxes: ['Fax could not be sent. Please check your internet connection and try again.']})
      return {errors: true}
    })
  }

  onSuccess = () => {
    this.props.confirmSent()
    this.props.closeDialog()
  }

  validatedFax = (phone,country) => {
    if (!this.state.phoneValidator) return true
    else {
      if (!phone) return false
      return this.state.phoneValidator.isValidNumber(phone,country || this.props.country.isOpen)
    }
  }

  getAllNumbers = () => {
    return this.getPhoneList()
      .filter(e => e)
  }

  validateAndConfirm = (e) => {
    e && e.preventDefault()
    const typedFaxes = this.getAllNumbers()
    const invalidPhoneNumbers = typedFaxes.filter(e => !this.validatedFax(e.phone || e,e.country))

    if (invalidPhoneNumbers.length) {
      this.props.form.connector.clearErrors()
    } else if (!typedFaxes.length) {
      this.props.form.connector.setErrors({
        faxes: [`At least one valid phone number is needed.`]
      })
    } else {
      this.props.confirmFaxDialog.open()
      this.props.form.connector.clearErrors()
    }
  }

  addFaxNumber = (fax) => {
    const form = this.props.form
    const faxes = form.properties.faxes || []
    const lastIsEditing = faxes.slice(-1).filter(_ => typeof _ === 'string').length
    form.connector.setValue('faxes', ice.spliceIn(faxes, [], lastIsEditing ? -1 : faxes.length, 0, {phone:fax,country:this.props.country.isOpen}))
  }

  getPhoneList = () => this.props.form.properties.faxes.map(_ => _.fax || _)

  phoneNumberValidation = (v) => this.validatedFax(v.trim()) ? {success: {phone: v.trim(), country: this.props.country.isOpen}} : {errors: [`"${v}" is not a valid phone number.`]}

  suggestions = (s) => []

  getFaxLabel = (_) => (_.phone || "")

  CompletedBox = ({value,label,remove}) => value.country ? <AddedNumber><CountryFlag className={"flag flag-"+value.country.toLowerCase()}/>+{this.getCountryCallingCode(value.country)} {value.phone} <AutoComplete.RemoveIcon icon="x" onClick={remove}/></AddedNumber> : null

  formatPhone = (phone) => this.state.phoneValidator ?
      new this.state.phoneValidator.AsYouType(this.props.country.isOpen).input(phone) : phone

  getCountryCallingCode = (country) => this.state.phoneValidator ?
    this.state.phoneValidator.getCountryCallingCode(country) : '1'

  render() {
    const {closeDialog, country, confirmFaxDialog, fax, form} = this.props
    const faxes = (form.properties.faxes || []).map(_ => _.phone)
    const suggested = (fax.suggestedNumbers || []).filter(_ => faxes.indexOf(_) < 0)
    return !confirmFaxDialog.isOpen ?
      (
        <Dialog
          closeDialog={closeDialog}
          confirm={this.validateAndConfirm}
          title="Send report via fax"
          className='dialog-send-fax'
        >
          <form onSubmit={this.validateAndConfirm}>
            <Dialog.Content>
              <p className="main-instruction">Sending a report via fax will deliver it to be printed by the fax
                recipient(s) according to the number(s) you insert below.</p>
              <AutoComplete
                form={form}
                EditableInput={(props) => <PhoneInput {...props} format={this.formatPhone} getCountryCallingCode={this.getCountryCallingCode} country={country}/>}
                getLabel={this.getFaxLabel}
                minQueryLength={1}
                deleteOnBackspace={false}
                confirmIfNewKeys={[' ']}
                CompletedBox={this.CompletedBox}
                defaultValue={[]}
                autoSelect
                validation={this.phoneNumberValidation}
                fetchSuggestions={this.suggestions}
                path="faxes"
                label="Fax number(s):"
              />
            <p className="post-field-description"><strong>Tip:</strong> Separate different fax numbers with a comma to send to multiple recipients.</p>
              {suggested.length > 0 &&
              <div className="suggested-faxes"><span>Suggestions: </span>
                {suggested.map((fax, i) =>
                  <span key={fax.phone}>
                    <a onClick={() => this.addFaxNumber(fax)}>{fax.phone}</a>
                    {i + 1 === suggested.length ? '' : ', '}
                  </span>
                )}
              </div>
              }
              <Errors form={form}/>
            </Dialog.Content>
            <Dialog.Footer>
              <Button onClick={closeDialog}>Cancel</Button>
              <Button type="submit" highlight>Send</Button>
            </Dialog.Footer>
          </form>
        </Dialog>
      ) : (
        <Dialog
          title="Confirm sending report"
          closeDialog={closeDialog}
          confirm={this.sendEmail}
          className='dialog-send-email'
        >
          <Dialog.Content>
            <div className="box">
              <span className="bold">Sending report to: </span>
              <ul className="sending-email-list">
                {this.getAllNumbers()
                  .map(({phone,country}) =>
                    <li key={phone}>{country}{phone}</li>
                  )}
              </ul>
            </div>
            <div className="additional-info">
              <h4>The fax your are about to send may contain confidential and protected health care information.</h4>
              <p>Please be sure that the fax number(s) of the recipient(s) are correct
                and that you are using appropriately confidential mechanisms for this transmission.</p>
            </div>
          </Dialog.Content>
          <Dialog.Footer>
            <Form form={form} onSuccess={this.onSuccess} handleSubmit={this.handleSubmit}>
              <Button onClick={confirmFaxDialog.close}>Return</Button>
              <Button autoFocus highlight isLoading={form.isLoading} type="submit">Confirm send</Button>
            </Form>
          </Dialog.Footer>
        </Dialog>
      )

  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/viewer/SendFaxDialog.jsx